'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$() {
}
export { $c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$ as $c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$ };
$p = $c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$;
/** @constructor */
function $h_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$() {
}
export { $h_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$ as $h_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$ };
$h_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$.prototype = $p;
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$, "app.data.organization_types$package$OrganizationOriginalDocumentWatermark$", ({
  GQ: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$ as $d_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$ };
var $n_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$;
function $m_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$() {
  if ((!$n_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$)) {
    $n_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$ = new $c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$();
  }
  return $n_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$;
}
export { $m_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$ as $m_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$ };
//# sourceMappingURL=app.data.organization_types$package$-Organization-Original-Document-Watermark$.js.map
